<template>
  <div class="filling">
    <div class="filling-dv">
      <div class="filling-dvh">
        <!-- <img src="../../assets/bg-xiangqing-lv.png" alt=""> -->
        <h1>问卷填写</h1>
      </div>
    </div>
    <div class="filling-dv1">
      <h3>{{ name }}</h3>
      <div v-for="(item, io) in listdata" :key="io">
        <ul>
          <li>
            <div class="title_tex" v-if="item.title !== ''">
              <!-- <img
                src="../../assets/bi.png"
                alt=""
                v-if="item.required"
                class="title_teximg"
              />
              <img src="../../assets/dian-biaoti.png" alt="" /> -->
              <div class="title_left">
                <div class="bi" v-if="item.required" />
                <div class="biaoti" />
              </div>
              <div class="title_right">
                <span>{{ item.title }}</span>
              </div>
            </div>
            <!-- 单选 -->
            <form action="" method="get" v-if="item.type == 'gradeRadio'">
              <label
                v-for="(vo, index) in item.items"
                :key="index"
                class="aaalable"
                @click="clickdiv(io, vo)"
              >
                <div :class="{ activespan1: vo.answer }" />
                <span>{{ vo.text }}</span>
              </label>
            </form>
            <!--   多选 -->
            <form action="" method="get" v-if="item.type == 'gradeCheckbox'">
              <label
                v-for="(co, index) in item.items"
                :key="index"
                class="aaalable"
                @click="clickdiv1(io, co)"
              >
                <!-- <img src="../../assets/duihao1.png" alt="" v-if="co.answer "> -->
                <span class="duihao" v-if="co.answer" />
                <i :class="{ activespan2: co.answer }" />
                <span>{{ co.text }}</span>
              </label>
            </form>
            <textarea
              placeholder="请填写这里..."
              cols="39"
              rows="6"
              v-if="item.type == 'baseTextArea' || item.type == 'baseRemark'"
              class="text_area"
              v-model="item.questionValue"
            />
            <input
              placeholder="请填写这里..."
              v-if="
                item.type == 'baseText' ||
                  item.type == 'name' ||
                  item.type == 'sex' ||
                  item.type == 'academy' ||
                  item.type == 'specialty' ||
                  item.type == 'industry' ||
                  item.type == 'profession'
              "
              class="text_area1"
              v-model="item.questionValue"
            />
            <input
              placeholder="请填写这里..."
              v-if="item.type == 'email'"
              class="text_area1"
              type="email"
              v-model="item.questionValue"
            />
            <input
              placeholder="请填写这里..."
              v-if="item.type == 'phone'"
              class="text_area1"
              v-model.number="item.questionValue"
              type="number"
            />
            <div v-if="item.type == 'uploadFile'">
              <p class="filenameCls" v-if="item.Filename">
                {{ item.Filename }}
              </p>
              <span class=" fileinput-button">
                <span v-if="item.Filename">重新上传</span>
                <span v-else>上传文件</span>
                <input
                  type="file"
                  name="file"
                  ref="inputFile"
                  @change="uploadChange(io, item)"
                />
              </span>
            </div>
            <div class="lplplp" v-if="item.type == 'matrixGauge'">
              <table
                cellspacing="1"
                cellpadding="1"
                border="1"
                class="el-table browsersupport"
              >
                <tr>
                  <th />
                  <th>{{ item.endDesc }}</th>
                  <th v-for="(items, y) in item.itemNum - 2" :key="y">
                    {{ items + 1 }}
                  </th>
                  <th>{{ item.startDesc }}</th>
                </tr>
                <tr v-for="(vo, voinde) in item.rowDesc" :key="voinde">
                  <td>
                    {{ vo.text }}
                  </td>
                  <td
                    v-for="(items, itemsindex) in item.itemNum"
                    :key="itemsindex"
                    @click="change(itemsindex, voinde, io, vo)"
                  >
                    <span
                      :class="{
                        activespan: vo.isindex == `${voinde}-${itemsindex}`
                      }"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="lplplp" v-if="item.type == 'baseGauge'">
              <table
                cellspacing="1"
                cellpadding="1"
                border="1"
                class="el-table1 browsersupport"
              >
                <tr>
                  <th>{{ item.endDesc }}</th>
                  <th v-for="(items, y) in item.itemNum - 2" :key="y">
                    {{ items + 1 }}
                  </th>
                  <th>{{ item.startDesc }}</th>
                </tr>
                <tr>
                  <td
                    v-for="(items, itemsindex) in item.itemNum"
                    :key="itemsindex"
                    @click="changebase(itemsindex, io)"
                  >
                    <span :class="{ activespan: baseindex == itemsindex }" />
                  </td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </div>
      <div class="filling-dv4" @click="submit">
        提交
      </div>
    </div>
    <back-to :path="'/MyQuestionaire'" />
  </div>
</template>
<script>
import backTo from "@/components/back";
import api from "@/api";
// import { callbackify } from "util";
export default {
  components: { backTo },
  data() {
    return {
      arrlist: [],
      textarea: "",
      inputval: "",
      danxuan: "",
      showradius: false,
      showradius1: true,
      isActive: -1,
      isActivespan: -1,
      filename: "",
      showsort: -1,
      upload: "上传",
      isindex: "",
      baseindex: -1,
      name: this.$route.query.names,
      formData: {},
      list: [],
      isSubmit: false,
      inputFileIndex: null,
      form: {
        formId: this.$route.query.formId,
        createUser: "",
        data: ""
      },
      api: {
        uploadUrl: `/system/file/editorUpload?x-token=${localStorage.getItem(
          "x_token"
        )}`,
        queryQuestionAll:
          "/form/rest/FormQuestionBaseBusiness/queryQuestionAll/v1",
        save: "/form/rest/FormAnserBusiness/save/v1"
      },
      listdata: []
    };
  },
  methods: {
    //  单选
    clickdiv(a, b) {
      this.listdata[a].items.forEach(item => {
        if (item.text == b.text) {
          item.answer = !item.answer;
          this.listdata[a].questionValue = item.text;
        } else {
          item.answer = false;
        }
      });
    },
    // 多选
    clickdiv1(a, b) {
      b.answer = !b.answer;
      this.listdata[a].questionValue.push(b.text);
    },
    change(itemsindex, voinde, io, vo) {
      this.isindex = `${voinde}-${itemsindex}`;
      const obj = {
        text: vo.text,
        isindex: `${voinde}-${itemsindex}`
      };
      this.$set(this.listdata[io].rowDesc, voinde, obj);
      this.listdata[io].questionValue.push(Number(itemsindex) + 1);
    },
    changebase(index, io) {
      this.baseindex = index;
      let num = index + 1;
      this.listdata[io].questionValue = num.toString();
    },
    uploadChange(io) {
      let files = this.$refs.inputFile[io].files[0];
      let formData = new window.FormData();
      formData.append("file", files);
      this.$post(this.api.uploadUrl, formData).then(res => {
        if (res.success === 0) {
          const imgId = res.id;
          this.listdata[io].questionValue = imgId;
          this.listdata[io].Filename = res.name;
        } else {
          this.$toast({
            duration: 1000,
            message: "上传失败，请重新上传",
            position: "bottom"
          });
        }
      });
    },
    queryQuestionAll() {
      let key = {
        formId: this.$route.query.formId
      };
      this.$post(api.questionnaire.Business(), key)
        .then(res => {
          let num = 0;
          this.formData = res.data.form;
          const arr = res.data.questions || [];
          arr.forEach(_vo => {
            if (_vo.type === "gradeCheckbox" || _vo.type === "matrixGauge") {
              _vo.questionValue = [];
            } else {
              _vo.questionValue = "";
            }
            if (_vo.type == "uploadFile") {
              _vo.Filename = "";
            }
            if (_vo.type === "splitLine" || _vo.type === "baseRemark") {
              _vo.sort = null;
            } else {
              num += 1;
              _vo.sort = num;
            }
          });
          this.listdata = arr;
          this.listdata.forEach(item => {
            if (item.type == "matrixGauge") {
              item.rowDesc.forEach(vo => {
                vo.isindex = "";
              });
            }
          });
        })
        .catch(err => {
          alert(err, "err");
        });
    },
    submit() {
      if (this.isSubmit) {
        this.$toast({
          message: "请勿重复提交！",
          duration: 1000,
          position: "bottom"
        });
      }
      //必填项校验
      if (!this.validateRequired(this.listdata)) {
        return;
      }
      const newList = JSON.parse(JSON.stringify(this.listdata));
      const submitArr = [];
      newList.forEach(item => {
        if (item.type !== "baseRemark" && item.type !== "splitLine") {
          let qVal = null;
          if (item.type === "gradeCheckbox") {
            qVal = item.questionValue;
          } else if (item.type === "matrixGauge") {
            const matrixGaugeArr = [];
            item.rowDesc.forEach(vo => {
              if (vo.isindex) {
                matrixGaugeArr.push(Number(vo.isindex.slice(2, 3)) + 1);
              }
            });
            qVal = matrixGaugeArr;
          } else if (item.type === "gradeRadio") {
            qVal = item.questionValue;
          } else if (item.type == "uploadFile") {
            qVal = item.questionValue;
          } else if (item.type == "phone") {
            qVal = item.questionValue.toString();
          } else {
            qVal = item.questionValue;
          }
          submitArr.push({
            questionId: item.id,
            questionValue: qVal
          });
        }
      });
      this.form.formId = this.$route.query.formId;
      this.form.data = JSON.stringify(submitArr);
      this.saveFn();
    },
    //校验函数
    validateRequired(arr) {
      let validate = false;
      for (let i = 0; i < arr.length; i++) {
        if (
          arr[i].type !== "baseRemark" &&
          arr[i].type !== "splitLine" &&
          arr[i].required
        ) {
          // const msg = scope => `${arr[i].sort}. ${arr[i].title} ${scope}`;
          if (
            (arr[i].type === "gradeRadio" || arr[i].type === "sex") &&
            !arr[i].questionValue
          ) {
            this.$toast({
              message: "是必选项，请选择选项",
              duration: 1000,
              position: "bottom"
            });
            validate = false;
            break;
          } else if (
            arr[i].type === "gradeCheckbox" &&
            arr[i].questionValue.length === 0
          ) {
            this.$toast({
              message: "是必选项，请选择选项",
              duration: 1000,
              position: "bottom"
            });
            validate = false;
            break;
          } else if (
            arr[i].type === "baseGauge" &&
            arr[i].questionValue === ""
          ) {
            this.$toast({
              message: "是必选项，请为选项打分",
              duration: 1000,
              position: "bottom"
            });
            validate = false;
            break;
          } else if (arr[i].type === "matrixGauge") {
            if (arr[i].questionValue.length == 0) {
              this.$toast({
                message: "是必选项，请为所有选项打分",
                duration: 1000,
                position: "bottom"
              });
              validate = false;
              break;
            } else {
              validate = true;
            }
          } else if (!arr[i].questionValue) {
            this.$toast({
              message: "是必填项，请输入内容  填空",
              duration: 1000,
              position: "bottom"
            });
            validate = false;
            break;
          } else if (arr[i].type === "phone") {
            if (!/^1[34578]\d{9}$/.test(arr[i].questionValue)) {
              this.$toast({
                message: "电话号码格式错误",
                duration: 1000,
                position: "bottom"
              });
              validate = false;
              break;
            } else {
              validate = true;
            }
          } else {
            validate = true;
          }
        } else {
          validate = true;
        }
      }
      return validate;
    },
    saveFn() {
      this.$post(this.api.save, this.form)
        .then(res => {
          if (res.code === 200) {
            this.isSubmit = true;
            this.$toast({
              message: "提交成功",
              duration: 1000,
              position: "bottom"
            });
            this.$router.push({
              path: "/completeQuestionnaire",
              query: {
                name: this.$route.query.names,
                formId: this.$route.query.formId
              }
            });
          } else {
            this.isSubmit = false;
            this.$toast({
              message: res.msg,
              duration: 1000,
              position: "bottom"
            });
          }
        })
        .catch(() => {
          this.isSubmit = false;
        });
    }
  },
  mounted() {
    this.queryQuestionAll();
  }
};
</script>
<style lang="scss" scoped>
.filling {
  .filling-dv {
    .filling-dvh {
      width: 100%;
      height: 140px;
      background: url("../../assets/bg-xiangqing-lv.png") no-repeat center
        center;
      background-size: 100% 100%;
      h1 {
        position: absolute;
        left: 50%;
        top: 55px;
        transform: translate(-50%, -50%);
        font-size: 36px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 5px;
      }
      img {
        width: 100%;
        height: 140px;
      }
    }
  }
  .filling-dv1 {
    position: absolute;
    top: 110px;
    background: rgba(255, 255, 255, 1);
    box-shadow: $box-shadow;
    border-radius: 40px 40px 0px 0px;
    width: 100%;
    height: 100%;
    .fileinput-button {
      width: 90%;
      height: 100%;
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin-left: 50px;
      background: #fff;
      border-radius: 4px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(3, 177, 135, 1);
      padding: 20px 15px;
      border: 1px solid rgba(3, 177, 135, 1);
      border-radius: 10px;
      text-align: center;
      margin-bottom: 60px;
    }
    .filenameCls {
      width: 90%;
      height: 100%;
      background: rgba(244, 244, 244, 1);
      border-radius: 10px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(50, 50, 50, 1);
      padding: 20px 15px;
      margin-top: 0;
    }
    .fileinput-button input {
      position: absolute;
      right: 0px;
      top: 0px;
      opacity: 0;
      font-size: 16px;
    }
    .aaalable {
      display: block;
      margin-left: 45px;
      margin-bottom: 30px;
      position: relative;
      img {
        width: 28px;
        height: 18px;
        position: absolute;
        left: 4px;
        top: 15px;
      }
      .duihao {
        width: 28px;
        height: 18px;
        position: absolute;
        left: -16px;
        top: 15px;
        background: url("../../assets/duihao1.png") no-repeat center center;
        background-size: 100% 100%;
      }
      input {
        float: left;
        width: 34px;
        height: 34px;
      }
      div {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        border-radius: 50%;
        display: inline-block;
        // float: left;
        margin-top: 8px;
      }
      i {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        // float: left;
        margin-top: 8px;
        display: inline-block;
      }
      .activespan1 {
        border: 8px solid rgba(3, 177, 135, 1);
      }
      .activespan2 {
        border: 1px solid rgba(3, 177, 135, 1);
        background-color: rgba(3, 177, 135, 1);
      }
      span {
        font-size: 24px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(150, 150, 150, 1);
        margin-left: 20px;
      }
    }
    .el-table {
      border-collapse: collapse;
      border: 1px solid #aaa;
      margin-bottom: 50px;
      flex: 1;
    }
    .el-table1 {
      border-collapse: collapse;
      border: 1px solid #aaa;
      margin-bottom: 50px;
      flex: 1;
    }
    table.browsersupport th {
      min-width: 105px;
      padding: 15px 10px;
      height: 40px;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #ddd;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(150, 150, 150, 1);
    }
    table.browsersupport td {
      width: 200px;
      padding: 25px 10px;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #ddd;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(150, 150, 150, 1);
      text-align: center;
      span {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        border-radius: 50%;
        display: inline-block;
      }
      .activespan {
        border: 8px solid rgba(3, 177, 135, 1);
      }
    }
    h3 {
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(50, 50, 50, 1);
      text-align: center;
      margin-top: 39px;
      margin-bottom: 59px;
    }
    ul {
      li {
        padding-left: 51px;
        padding-right: 51px;
        position: relative;
        .title_teximg {
          position: absolute;
          left: 10px;
          top: 0;
        }
        .title_tex {
          margin-bottom: 20px;
          img {
            width: 40px;
            height: 22px;
            margin-right: 10px;
            float: left;
            margin-top: 6px;
          }
          .title_left {
            width: 55px;
            float: left;
            .biaoti {
              margin-top: 13px;
              float: left;
              width: 45px;
              height: 25px;
              background: url("../../assets/dian-biaoti.png") no-repeat center
                center;
              background-size: 100% 100%;
            }
            .bi {
              margin-top: 13px;
              float: left;
              width: 45px;
              height: 25px;
              background: url("../../assets/bi.png") no-repeat center center;
              background-size: 100% 100%;
              position: absolute;
              left: 10px;
              top: 0;
            }
          }
          .title_right {
            // float: right;
            span {
              font-size: 24px;
              font-family: PingFangSC;
              font-weight: 700;
              color: #323232;
              word-wrap: break-word;
              word-break: break-all;
              overflow: hidden;
            }
          }
        }
        .lplplp {
          display: flex;
          overflow-x: auto;
          -ms-overflow-style: none;
          overflow: -moz-scrollbars-none;
          margin-bottom: 40px;
          &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
          }
        }
        p {
          font-size: 22px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(150, 150, 150, 1);
          line-height: 36px;
          letter-spacing: 2px;
          margin-left: 50px;
          margin-top: 27px;
          margin-bottom: 27px;
        }
        .text_area {
          margin-bottom: 60px;
          margin-left: 50px;
          padding-top: 40px;
          padding-left: 30px;
          border: 1px solid rgba(221, 221, 221, 1);
          border-radius: 10px;
          width: 89%;
          font-size: 20px;
          color: #666;
        }
        .text_area1 {
          margin-bottom: 60px;
          margin-left: 50px;
          padding-top: 20px;
          padding-bottom: 20px;
          padding-left: 30px;
          border: 1px solid rgba(221, 221, 221, 1);
          border-radius: 10px;
          width: 89%;
          font-size: 20px;
          color: #666;
        }
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(204, 204, 204, 1) !important;
        }
      }
    }
  }
  .filling-dv4 {
    width: 650px;
    height: 100px;
    background: linear-gradient(
      90deg,
      rgba(142, 233, 202, 1) 0%,
      rgba(3, 177, 135, 1) 100%
    );
    box-shadow: 0px 0px 30px 0px rgba(156, 233, 200, 0.6);
    border-radius: 50px;
    margin: 0 auto;
    margin-bottom: 180px;
    text-align: center;
    color: #fff;
    line-height: 100px;
  }
}
</style>
